import type { ChapterEnum } from 'gql/graphql';

import * as R from 'ramda';

const getCheckedFilterValue = (filters: Record<string, string[]>) => {
    const predicates = Object.entries(filters)
        .filter(([, values]) => values.length)
        .map(([fieldName, values]) => ({
            [fieldName]: {
                in: values,
            },
        }));

    return predicates.length
        ? {
              and: predicates,
          }
        : {};
};

export const getWhere = (chapter: ChapterEnum | undefined, filters: Record<string, any> = {}) => {
    const { searchString, ...rest } = filters || {};

    const filtersWhere = getCheckedFilterValue(rest);

    const stringWhere = searchString && {
        or: [
            {
                sectionName: { containsi: searchString },
            },
            {
                groupFullName: {
                    containsi: searchString,
                },
            },
            {
                code: { containsi: searchString },
            },
            {
                name: {
                    containsi: searchString,
                },
            },
        ],
    };

    const chapterWhere = chapter && {
        chapter: {
            eq: chapter,
        },
    };

    if (stringWhere && !R.isEmpty(filtersWhere)) {
        return {
            and: [stringWhere, filtersWhere, chapterWhere],
        };
    }

    if (stringWhere) {
        return { ...stringWhere, ...chapterWhere };
    }

    if (!R.isEmpty(filtersWhere)) {
        return { ...filtersWhere, ...chapterWhere };
    }

    return undefined;
};
